
export const FOODIE_MEAL_TIME_MODEL = {
    id: null,
    name: '',
    startTime: '',
    endTime: '',
    cost: '',
    isValid: function (showCostInfo) {
        return this.name !== '' && this.startTime != null && this.startTime !== ''
            && this.endTime != null && this.endTime !== '' &&
            (!showCostInfo || (showCostInfo && this.cost !== null && this.cost !== ''));
    },
    toAddEdit: function () {
        return {
            id: this.id,
            name: this.name,
            startTime: this.startTime,
            endTime: this.endTime,
            cost: this.cost
        }
    }
}

export const FOODIE_ACCESS_MODEL = {
    id: null,
    assignedToId: null,
    requestedById: null,
    foodieCafeteriaId: null,
    fromTime: null,
    toTime: null,
    description: null,
    isValid: function () {
        return this.foodieCafeteriaId != null
            && this.fromTime != null
            && this.toTime != null
            && this.description !== null
            && this.description !== undefined
            && this.description.trim() !== '';
    },
    toRegister: function (assignedToId) {
        return {
            id: this.id,
            assignedToId: assignedToId,
            requestedById: this.requestedById,
            foodieCafeteriaId: this.foodieCafeteriaId,
            fromTime: new Date(this.fromTime).getTime(),
            toTime: new Date(this.toTime).getTime(),
            description: this.description
        }
    }
}
